import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Tabs, Tab } from "react-bootstrap";

import { journalTabs } from "./helper";

const JournalTabs = ({ date, range }) => {
	const [activeTab, setActiveTab] = useState(0);

	const renderTabs = () => {
		return (
			journalTabs &&
			journalTabs.map((step, i) => {
				const SpecificStep = step.component;
				const specificData = step.data;
				return (
					<Tab key={step.id} eventKey={i} title={step.title}>
						<SpecificStep
							data={specificData}
							date={date}
							type={step.type ? step.type : null}
							setActiveTab={setActiveTab}
							range={range}
						/>
					</Tab>
				);
			})
		);
	};

	return (
		<React.Fragment>
			<Tabs activeKey={activeTab} className="pt-2 border-0" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
				{renderTabs()}
			</Tabs>
		</React.Fragment>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(withRouter(JournalTabs));
